function showAlert(message) {
	alert(message);
}

var onAjaxContentLoad;

(function () {

	var PLATFORM_DESKTOP = 'PLATFORM_DESKTOP';
	var PLATFORM_MOBILE = 'PLATFORM_MOBILE';

	var platform = PLATFORM_DESKTOP;
	var page;
	var resizeTimer;


	/**
	 * Global functions
	 */

	function initNavbarMobile() {
		var navIcon = $('#navIcon');
		var navbar = $('.mobileNavTop .mainNav ul#navbar');

		navIcon.click(function (event) {
			event.preventDefault();
			$(this).toggleClass('open');
			if (navbar.hasClass('open')) {
				navbar.slideUp(300).removeClass('open');
			} else {
				navbar.slideDown(300).addClass('open');
			}
		});
	}

	function initSubMenuMobile() {
		var subMenuButton = $('#subMenuButton');
		var subMenuContainer = $('#subMenuContainer');

		subMenuButton.click(function (event) {
			event.preventDefault();
			subMenuContainer.slideToggle(300);
		});
	}


	function initMainMenuSubNav() {
		var mainMenuContainer = $('ul#navbar li');

		var delayIn = 490;
		var delayOut = 500;
		if (platform === PLATFORM_MOBILE) {
			delayIn = 0;
			delayOut = 0;
		}

		mainMenuContainer.hover(function () {
			$(this).children('.subNav').stop(true).delay(delayIn).fadeIn(0);
		}, function () {
			$(this).children('.subNav').stop(true).delay(delayOut).fadeOut(0);
		});
	}


	function initSearchInputOpen() {
		var searchIcon = $('.searchIcon');
		var searchInputWrapper = $('.searchInput');
		var closeButton = $('span.close');
		var searchInput = $('.searchInput form input[type=search]');

		searchIcon.click(function (event) {
			event.preventDefault();
			$(this).hide(300).addClass('open');
			if (Gridle.isActive('mobile')) {
				$('header').animate({ 'paddingBottom': '5em' }, 300);
			}
			$(this).parents('.widget.search').find('.searchInput').show(300).addClass('open');
			searchInput.focus();
		});

		closeButton.click(function (event) {
			event.preventDefault();
			if (Gridle.isActive('mobile')) {
				$('header').animate({ 'paddingBottom': '1.5em' }, 300);
			}
			searchIcon.show(300).removeClass('open');
			searchInputWrapper.hide(300).removeClass('open');
		});
	}


	function initMatchHeight() {
		var matchHeightsubNav = $('div.subNav ul li');
		var matchHeightCard = $('.homepageArticles article .card');
		var matchHeightInstitute = $('.institute .itemBox');
		var matchHeightEmployees = $('.employees .itemBox');
		var matchHeightBookImage = $('.books .item img');

		matchHeightCard.add(matchHeightsubNav).add(matchHeightInstitute).add(matchHeightEmployees).add(matchHeightBookImage).matchHeight({
			byRow: true,
			property: 'min-height',
			target: null,
			remove: false
		});
	}


	function initMatchHeightUpdate() {
		$(window).on('resize orientationchange', function (e) {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				initMatchHeight();
			}, 300);
		});
	}


	function initBookTracking() {
		$('a.bookTracking').click(function (e) {
			var link = $(this);
			var url = link.attr('href');
			var action = link.data('action');
			var title = link.data('title');
			if (url) {
				TrackingUtils.trackEvent('Book', action, title + ' (' + url + ')');
			}
			return true;
		});
	};


	function initNakiSearchForm() {
		var formContainer = $('#naki-search');
		if (formContainer.length === 1) {
			var nakiSearch = new NakiSearchForm(formContainer);
		}
	}


	function initResearchRequestForm() {
		var formContainer = $('#research-request-form');
		if (formContainer.length === 1) {
			var form = new ResearchRequestForm(formContainer);
		}
	}


	function initNewsletterForm() {
		var formContainer = $('#newsletter-form');
		if (formContainer.length === 1) {
			var form = new NewsletterForm(formContainer);
		}
	}


	function initConferenceForm() {
		var formContainer = $('#conference-form');
		if (formContainer.length === 1) {
			var form = new ConferenceForm(formContainer);
		}
	}


	function initFootnotes() {
		var footnotes = new Footnotes($('main'));
	}


	function initGallery() {
		$('.editorContent div.gallery').each(function () {
			var gal = new Gallery($(this));
		});
	}


	function initAccordion() {
		$('.editorContent div.accordion .item').each(function () {
			var acc = new Accordion($(this));
		});
		$('.editorContent span.accordion-inline').each(function () {
			var accInline = new AccordionInline($(this));
		});
	}


	function initImageCaption() {
		$('.imageCaptions img').each(function () {
			if($(this).attr('alt') !== '') {
				var img = new ImageCaption($(this));
			}
		});
	}


	/**
	 * Run callback after AJAX content is loaded,
	 * so necessary processing is done with loaded content
	 */
	onAjaxContentLoad = function () {
		EmailUtils.initEncodedEmailLinks(appConfig.emailEncSecret);
	};


	/**
	 * Init
	 */
	$(document).ready(function () {

		/**
		 * Detect platform
		 */
		if ($('html').hasClass('phone') || $('html').hasClass('tablet')) {
			platform = PLATFORM_MOBILE;
		}


		/**
		 * Init tracking, sharing
		 */
		TrackingUtils.initExternalLinkTracking();
		SharingUtils.initShareLinks();
		EmailUtils.initEncodedEmailLinks(appConfig.emailEncSecret);
		NavigationUtils.initScrollToElementLinks();


		/**
		 * Global init
		 */
		initMainMenuSubNav();
		initSubMenuMobile();
		initNavbarMobile();
		initSearchInputOpen();
		initMatchHeight();
		initMatchHeightUpdate();
		initNakiSearchForm();
		initResearchRequestForm();
		initNewsletterForm();
		initConferenceForm();
		initFootnotes();
		initGallery();
		initAccordion();
		initImageCaption();


		/**
		 * Platform-specific init
		 */
		if (platform === PLATFORM_MOBILE) {
			//
		}


		/**
		 * Page-specific init
		 */
		var templateId = parseInt($('body').data('tpl'));
		switch (templateId) {

			case 7:
				// Department
				page = new PageDepartmentController($('body'));
				break;

			case 13:
				// Book list
				page = new PageBookListController($('body'));
				initBookTracking();
				break;

			case 10:
			case 28:
				// Book
				initBookTracking();
				break;

		}

	});

})();
